import ResourceCard from '@components/national-coding-olympiad-2021/thank-you-page/resource-card'
import { ResourceDataType } from '@lib/types/nco-thank-you-page'

type Props = {
  heading?: string
  imagePath: string
  ctaText: string
  resourceData: ResourceDataType[]
}
const AppDevelopmentMasterclass = ({
  heading,
  imagePath,
  ctaText,
  resourceData,
}: Props) => (
  <div className="container mx-auto text-grey-900 px-2 md:px-0">
    {heading && (
      <h3 className="font-700 text-center text-4xl pt-10">{heading}</h3>
    )}
    <div className="flex flex-wrap justify-center md:flex-row space-y-6 md:space-y-0 md:gap-8 pb-20 pt-10">
      {resourceData.map(({ imageName, title, ctaLink }) => (
        <ResourceCard
          key={ctaLink}
          imagePath={imagePath}
          imageName={imageName}
          title={title}
          ctaLink={ctaLink}
          ctaText={ctaText}
        />
      ))}
    </div>
  </div>
)
export default AppDevelopmentMasterclass
